import { render, staticRenderFns } from "./BdrOneCSidebar.vue?vue&type=template&id=60a00796&"
import script from "./BdrOneCSidebar.vue?vue&type=script&lang=js&"
export * from "./BdrOneCSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports